import { render, staticRenderFns } from "./GlossaryRegions.vue?vue&type=template&id=443d4c47&scoped=true&"
import script from "./GlossaryRegions.vue?vue&type=script&lang=js&"
export * from "./GlossaryRegions.vue?vue&type=script&lang=js&"
import style0 from "./GlossaryRegions.vue?vue&type=style&index=0&id=443d4c47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443d4c47",
  null
  
)

export default component.exports